<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  <ng-container *ngIf="authFacade.showSuccessMessage$ | async; else showRequestPasswordForm">
    <h3 class="text-center">{{ t('success.header') }}</h3>
    <p class="f-size-sm my-4" [innerHtml]="t('success.checkmail', { email: form.value.email })"></p>

    <rx-button
      buttonClass="primary"
      [flexible]="true"
      [routerLink]="addAbsolutePathPrefix(authRoutes.ResetPassword)"
      [queryParams]="{ email: form.get('email').value }"
      *ngIf="authConfig.authProvider !== AuthProvider.Legacy; else legacySuccessButton"
    >
      {{ t('success.gotIt') }}
    </rx-button>

    <hr class="border-top my-3" />

    <p
      class="f-size-xs mb-2"
      *ngIf="authConfig.loginContactName && authConfig.loginContactEmail"
      [innerHTML]="
        t('success.problem', {
          name: authConfig.loginContactName,
          email: authConfig.loginContactEmail
        })
      "
    ></p>
  </ng-container>
  <ng-template #showRequestPasswordForm>
    <h3 class="text-center mb-4">{{ t('header') }}</h3>
    @if (showHelperText()) {
    <p class="f-size-xs f-color-regular text-center mb-4">{{ t('helperText') }}</p>
    }
    <rx-alert *ngIf="authFacade.error$ | async" type="danger" [message]="t('error.emailNotExisting')"></rx-alert>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <div class="form-group">
        <rx-input
          formControlName="email"
          type="email"
          [placeholder]="t('form.label.emailPlaceholder')"
          [label]="t('form.label.email')"
        >
          <div rx-error>
            <div *ngIf="isFieldInvalid(form, 'email', 'required')">
              {{ t('error.emailMissing') }}
            </div>
            <div *ngIf="isFieldInvalid(form, 'email', 'email')">
              {{ t('error.emailInvalid') }}
            </div>
          </div>
        </rx-input>
      </div>

      <rx-button type="submit" buttonClass="primary" [flexible]="true" [disabled]="authFacade.isLoading$ | async">
        <span *ngIf="(authFacade.isLoading$ | async) === false; else isLoading">
          {{ t('button.active') }}
        </span>
        <ng-template #isLoading>
          {{ t('button.loading') }}
        </ng-template>
      </rx-button>
    </form>
    <a class="d-block w-100 text-left mt-2 f-size-xs" [routerLink]="addAbsolutePathPrefix(authRoutes.Login)">
      {{ t('loginLink') }}
    </a>
  </ng-template>

  <ng-template #legacySuccessButton>
    <rx-button
      buttonClass="primary"
      [flexible]="true"
      [routerLink]="addAbsolutePathPrefix(authRoutes.Login)"
      *ngIf="authConfig.authProvider"
    >
      {{ t('success.button') }}
    </rx-button>
  </ng-template>
</ng-container>
